import { render, staticRenderFns } from "./ABView.vue?vue&type=template&id=60cb91ff&scoped=true"
import script from "./ABView.vue?vue&type=script&lang=js"
export * from "./ABView.vue?vue&type=script&lang=js"
import style0 from "./ABView.vue?vue&type=style&index=0&id=60cb91ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb91ff",
  null
  
)

export default component.exports